/**
 * Util function to be used as default parameter for callbacks, or optional functions
 * implementations.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noOp(): any {}
